<div class="privilege-shell p-2 p-lg-2">
  <div class="privilege-panel">
    <div class="privilege-header">
      <div class="header-copy">
        <button class="back-link" type="button" (click)="goBack()">
          <lucide-icon [img]="ChevronLeftIcon" [size]="16"></lucide-icon>
          <span>Back to Vendor</span>
        </button>
        <div class="title-wrap">
          <span class="title-icon">
            <lucide-icon [img]="ShieldCheckIcon" [size]="18"></lucide-icon>
          </span>
          <div>
            <h1 class="m-0">Vendor User Privileges</h1>
            <p class="m-0">{{ user()?.name || user()?.username || 'Vendor User' }}</p>
            <div class="user-meta">
              <span class="meta-pill">{{ user()?.username || '-' }}</span>
              <span class="meta-pill">{{ user()?.department || '-' }}</span>
              <span class="meta-pill">{{ user()?.designation || '-' }}</span>
            </div>
          </div>
        </div>
      </div>

      <button class="save-btn" type="button" [disabled]="saving() || loading()" (click)="savePrivileges()">
        <lucide-icon [img]="SaveIcon" [size]="16"></lucide-icon>
        <span>{{ saving() ? 'Saving...' : 'Save Changes' }}</span>
      </button>
    </div>

    <div class="toolbar">
      <div class="search-wrap">
        <lucide-icon [img]="SearchIcon" [size]="16"></lucide-icon>
        <input class="form-control" placeholder="Search menus" [value]="search()" (input)="onSearch(($any($event.target).value || '').toString())" />
      </div>
      <div class="toolbar-note">
        Vendor Profile starts with default write access. Other menus appear based on saved privileges.
      </div>
    </div>

    @if (error()) {
      <div class="banner-error">{{ error() }}</div>
    }

    @if (loading()) {
      <div class="empty-state">Loading privileges...</div>
    } @else if (rows().length === 0) {
      <div class="empty-state">No privilege rows found.</div>
    } @else {
      <div class="privilege-body">
        <div class="privilege-subhead privilege-subhead--global">
          <span>All Visible Menus</span>
          <div class="subhead-actions">
            <label class="check-chip"><input type="checkbox" [checked]="allReadSelected()" (change)="toggleAll('can_read', $any($event.target).checked)" /> Read</label>
            <label class="check-chip"><input type="checkbox" [checked]="allWriteSelected()" (change)="toggleAll('can_write', $any($event.target).checked)" /> Write</label>
          </div>
        </div>

        @for (group of groupedRows(); track group.label) {
          <section class="group-card">
            <div class="privilege-subhead">
              <span>{{ group.label }}</span>
              <div class="subhead-actions">
                <label class="check-chip"><input type="checkbox" [checked]="isGroupSelected(group.items, 'can_read')" (change)="toggleGroup(group.items, 'can_read', $any($event.target).checked)" /> Read</label>
                <label class="check-chip"><input type="checkbox" [checked]="isGroupSelected(group.items, 'can_write')" (change)="toggleGroup(group.items, 'can_write', $any($event.target).checked)" /> Write</label>
              </div>
            </div>

            @for (row of group.items; track row.menu_id) {
              <div class="privilege-row" [class.parent-row]="isParentRow(row)">
                <div class="row-title" [style.padding-left.px]="(row.level || 0) * 16">
                  <span>{{ row.menu_name }}</span>
                  @if (row.parent_name) {
                    <small>{{ row.parent_name }}</small>
                  }
                </div>
                <div class="row-actions">
                  <label class="check-chip"><input type="checkbox" [checked]="row.can_read" (change)="toggleRow(row, 'can_read', $any($event.target).checked)" /> Read</label>
                  <label class="check-chip"><input type="checkbox" [checked]="row.can_write" (change)="toggleRow(row, 'can_write', $any($event.target).checked)" /> Write</label>
                </div>
              </div>
            }
          </section>
        }
      </div>
    }
  </div>
</div>
